import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { unlockContent } from '../services/newsletterService';
import { getUserGeoData } from '../services/geoService';

const ContentGate = ({ onUnlocked, standalone = false }) => {
  const { t } = useTranslation();
  const [geoData, setGeoData] = useState(null);

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [institution, setInstitution] = useState('');
  const [reason, setReason] = useState('');
  const [notifications, setNotifications] = useState(false);

  const [status, setStatus] = useState(null); // 'loading', 'success', 'error'

  useEffect(() => {
    getUserGeoData().then(setGeoData).catch(() => setGeoData(null));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }

    setStatus('loading');

    const additionalData = {
      name,
      institution,
      reason,
      notifications
    };

    const handleSuccess = () => {
      setStatus('success');
      localStorage.setItem('spain_project_unlocked', 'true');
      if (onUnlocked) {
        setTimeout(() => {
          onUnlocked();
        }, 1500);
      }
    };

    unlockContent(email, additionalData, geoData)
      .then(handleSuccess)
      .catch((err) => {
        console.error("Error unlocking content:", err);
        handleSuccess();
      });
  };

  return (
    <div className={`ContentGate-wrap ${standalone ? 'ContentGate-wrap--standalone' : ''}`}>
      {!standalone}
      <div className="ContentGate-modal NewsletterPage">
        <h2 className="NewsletterPageTitle" style={{ fontSize: '1.8em', marginBottom: '10px' }}>
          {t('newsletter.title', 'Registro de visitantes')}
        </h2>
        <p className="NewsletterPageDescription" style={{ fontSize: '15px', marginBottom: '15px', lineHeight: '1.5' }}>
          {t('newsletter.intro1')}
        </p>
        <p className="NewsletterPageDescription" style={{ fontSize: '15px', marginBottom: '15px', lineHeight: '1.5' }}>
          {t('newsletter.intro2')}
        </p>
        <p className="NewsletterPageDescription" style={{ fontSize: '15px', marginBottom: '30px', fontWeight: '500' }}>
          {t('newsletter.description')}
        </p>

        {status === 'success' ? (
          <p className="NewsletterMessage NewsletterMessageSuccess" style={{ fontSize: '1.2em' }}>
            {t('contentGate.success', '¡Gracias! Desbloqueando contenido...')}
          </p>
        ) : (
          <form className="ContentGate-form" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

            <div className="NewsletterFormGroup">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('contentGate.emailPlaceholder', 'Correo electrónico *')}
                className="NewsletterInput"
                required
              />
            </div>

            <div className="NewsletterFormGroup">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('contentGate.namePlaceholder', 'Nombre')}
                className="NewsletterInput"
              />
            </div>

            <div className="NewsletterFormGroup">
              <input
                type="text"
                value={institution}
                onChange={(e) => setInstitution(e.target.value)}
                placeholder={t('contentGate.institutionPlaceholder', 'Institución / Actividad')}
                className="NewsletterInput"
              />
            </div>

            <div className="NewsletterFormGroup">
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder={t('contentGate.reasonPlaceholder', '¿Cómo llegaste a esta web y qué temas te interesan?')}
                className="NewsletterInput"
                style={{ minHeight: '80px', paddingTop: '15px', resize: 'vertical' }}
              />
            </div>

            <label className="ContentGate-checkboxLabel" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '0.9em', color: 'rgba(255,255,255,0.8)', cursor: 'pointer', textAlign: 'left' }}>
              <input
                type="checkbox"
                checked={notifications}
                onChange={(e) => setNotifications(e.target.checked)}
                style={{ marginTop: '4px', transform: 'scale(1.2)' }}
              />
              {t('contentGate.notificationsLabel', 'Quiero recibir notificaciones sobre próximos eventos y avances del proyecto')}
            </label>

            <button type="submit" className="NewsletterButton" disabled={status === 'loading'} style={{ marginTop: '10px' }}>
              {status === 'loading' ? 'Enviando...' : t('contentGate.button', 'Acceder al contenido completo')}
            </button>

            <div className="ContentGate-privacyNotice" style={{ marginTop: '15px', fontSize: '13px', textAlign: 'justify', lineHeight: '1.4' }}>
              <p style={{ marginBottom: '8px' }}>{t('newsletter.privacyNotice')}</p>
              <p>{t('newsletter.contact')} <a href="mailto:anyely.marin.c@gmail.com">anyely.marin.c@gmail.com</a></p>
            </div>

            {status === 'error' && (
              <p className="NewsletterMessage NewsletterMessageError">{t('newsletter.error')}</p>
            )}

          </form>
        )}
      </div>
    </div>
  );
};

export default ContentGate;
